/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Section_Reading_RateInputs */

const en_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const fr_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const de_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const it_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const ru_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const es_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const zh_cn2_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const ja_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const hi_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const pt_pt2_options_metrics_section_reading_rate = /** @type {(inputs: Options_Metrics_Section_Reading_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

/**
* | output |
* | --- |
* | "Reading Rate" |
*
* @param {Options_Metrics_Section_Reading_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_section_reading_rate = /** @type {((inputs?: Options_Metrics_Section_Reading_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Section_Reading_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_section_reading_rate(inputs)
	if (locale === "de") return de_options_metrics_section_reading_rate(inputs)
	if (locale === "it") return it_options_metrics_section_reading_rate(inputs)
	if (locale === "ru") return ru_options_metrics_section_reading_rate(inputs)
	if (locale === "es") return es_options_metrics_section_reading_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_section_reading_rate(inputs)
	if (locale === "ja") return ja_options_metrics_section_reading_rate(inputs)
	if (locale === "hi") return hi_options_metrics_section_reading_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_section_reading_rate(inputs)
	return en_options_metrics_section_reading_rate(inputs)
});